import { Card } from '../../../base/Card/Card';
import { SvgIcon } from '../../../base/Icon/SvgIcon';
import type { JourneyPlan } from '../../../../arcticapi/types';
import {
  formatDuration,
  formatItineraryTimeRange,
  getItineraryDurationMinutes,
  getItineraryStartBannerText,
} from '../formatters';
import { StepSummary } from '../StepSummary/StepSummary';
import styles from './JourneyPlanItinerarySummary.module.css';

export interface JourneyPlanItinerarySummaryProps {
  plan: JourneyPlan;
  index: number;
  onSelectPlan: (index: number) => void;
  searchedDate?: string | null;
  isSameDay?: boolean;
  now?: Date;
}

/**
 * Summary block for a single itinerary option.
 *
 * Intended for headline details like duration and transfer overview.
 */
export function JourneyPlanItinerarySummary({
  plan,
  index,
  onSelectPlan,
  searchedDate = null,
  isSameDay = false,
  now,
}: JourneyPlanItinerarySummaryProps) {
  const bannerText = getItineraryStartBannerText({
    plan,
    searchedDate,
    isSameDay,
    now,
  });

  return (
    <header aria-label={`Itinerary ${index + 1}`}>
      <a
        className={styles.link}
        href="#"
        onClick={(event) => {
          event.preventDefault();
          onSelectPlan(index);
        }}
      >
        <Card>
          {bannerText && <p className={styles.banner}>{bannerText}</p>}
          <div className={styles.result}>
            <div className={styles.head}>
              <strong className={styles.timeRange}>
                {formatItineraryTimeRange(plan)}
              </strong>
              <p className={styles.duration}>
                {formatDuration(getItineraryDurationMinutes(plan))}
              </p>
            </div>
            <StepSummary className={styles.stepSummary} legs={plan.legs} />
            <div className={styles.footer}>
              <span className={styles.footerAction}>
                <span>View full itinerary</span>
                <SvgIcon
                  className={styles.footerChevron}
                  name="chevronRight"
                  strokeWidth="0"
                />
              </span>
            </div>
          </div>
        </Card>
      </a>
    </header>
  );
}
